export default "__VITE_ASSET__d948517f__"